import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-approval-menu',
  templateUrl: './approval-menu.component.html',
  styleUrls: ['./approval-menu.component.scss'],
  imports: [MatButtonModule, MatMenuModule, MatIconModule],
})
export class ApprovalMenuComponent {
  @Input() recordStatus: string;
  @Input() recordType: string;
  @Output() toggleStatus = new EventEmitter();
}
